export const teamsDg = `
<div class="screen-overlay teamsdg-overlay">
	<div class="teamsdg dialog">
		<div class="dialog-header">Music Teachers</div>
		<div class="teamsdg-page1">
			<div class="teamsdg-descriptionDiv">
				<p>
					<span class="emphasis">
						How do team competitions work?&nbsp;
					</span>
					Team competitions are intended to create excitement around music
					practice and generate positive peer encouragement among your 
					students. Create a team for each of your music classes and challenge 
					your students to see which class can finish highest on the world 
					leaderboard each week. Make up your own rewards to make it even more 
					exciting!
				</p>
				<p>
					When you create a team, you enter a unique team	name and a team code 
					that you can share with each of your students. Your students enter 
					this code when they add their names to the application. When 
					students play songs in RecorderAce, they earn	points that are 
					uploaded and combined with the points earned by	their classmates. 
					Points are not averaged, so every student's contributions, no matter
					how small, only help the team. It's impossible to see how much any
					particular student has contributed, and there is no pressure on 
					individual performance.
				</p>
				<p>
					<span class="emphasis">
						Can I use this to track my students' grades?&nbsp;
					</span>
					No, your students' scores are not retained separately, and there is 
					no way to associate points earned with each student. Student names 
					are not uploaded to the server. A future version of RecorderAce may 
					offer separate functionality for gradebook tracking, but that will 
					require separate opt-in from both	teachers and students/parents.
				</p>
				<p>
					<span class="emphasis">
						Can my students track their scores without entering a team code?
						&nbsp;
					</span>
					Yes. Your students can enter their names and leave the team code box 
					blank. Note that students	can not add a team to their names 
					afterwards. This is necessary to prevent students from accidentally 
					editing or deleting their classmates' names. If students need to add 
					themselves to a team, they can add their name to the list again and 
					include the team code.
				</p>
				<p>
					<span class="emphasis">
						Is student audio or video data ever uploaded?
						&nbsp;
					</span>
					No. RecorderAce listens to your students through the microphone in
					order to score their performances, and all of this takes place on
					the student's computer. Audio is never uploaded. RecorderAce does
					not use the camera.
				</p>
				<p>
					<span class="emphasis">Click Sign In to set up and manage teams for 
						your students.
					</span> 
					Note: If you previously created an account with Google Sign-In
					and set up teams, please use your same email to create a new 
					account on the sign-in page. We're no longer using Google Sign-In,
					but by using the same email you used previously, you will connect
					your new account to any team data you set up. We decided that
					Google Sign-In presented more drawbacks than advantages for
					classroom use. 
				</p>
			</div>
		</div>
		<div class="teamsdg-page2">
			<div class="teamsdg-descriptionDiv">
				Manage your teams:
			</div>
			<div class="teamsdg-teamsListDiv">
			</div>
		</div>
		<div class="teamsdg-page3">
			<div class="dialog-fields-section">
				<div class="teamsdg-fieldInstructionsDiv">
					Enter a unique name for this team. This will appear on the team
					leaderboard.
				</div>
				<div class="dialog-textfield">
					<input class="teamsdg-teamNameInput" type="text"
						placeholder="Team Name (30 character max)" maxlength="30"/>
				</div>
				<div class="teamsdg-fieldInstructionsDiv">
					Create a code for this team to share with your students. When your
					students create their usernames, they will enter this code to join
					this team.
				</div>
				<div class="dialog-textfield">
					<input class="teamsdg-codeInput" type="text"
						placeholder="Team Code (10 character max)" maxlength="10"/>
				</div>
				<div class="teamsdg-fieldInstructionsDiv">
					Enter the approximate number of students who will join this team.
					Team size is used to help balance scoring. You can change this
					later.
				</div>
				<div class="teamsdg-teamSizeDiv">
					<input class="teamsdg-teamSizeInput" type="number" value="20" 
						min="1" step="1"/>
				</div>
			</div>
			<div class="teamsdg-message">
			</div>
		</div>
		<div class="teamsdg-buttons dialog-buttons-section">
			<button class="teamsdg-btn1 dialog-button">Add Team</button>
			<button class="teamsdg-btn2 dialog-button">Remove Team</button>
			<button class="teamsdg-btn3 dialog-button">Close</button>
		</div>
		<div class="betaMessage">
			<span>Update: </span>Dear teachers, I'm seeking feedback on a new
			application I'm building.
			<a href="/LCTeacherInfo" target="_blank">Learn more here!</a>
			Thank you!
		</div>
	</div>
</div>
`;

export const teamMenuItem = `
<div class="teamsdg-teamItem">
	<div class="teamsdg-ti-info"></div>
	<div class="teamsdg-ti-size">
		<label class="teamsdg-ti-sizeLbl">Size: </label>
		<input class="teamsdg-ti-sizeInput" type="number" min="1" step="1"/>
		<button class="teamsdg-ti-saveBtn">Save</button>
	</div>
</div>
`;